<template>
    <div>
    </div>
</template>

<script>
    import socketio from 'socket.io-client';
    export default {
        props: ['token'],
        data: function () {
            return {
                form: {},
                errors: {}
            };
        },
        methods: {
            use: function () {
                localStorage.setItem('token', this.token);
                this.$service.defaults.headers.common['token'] = this.token;
                this.$bgService.defaults.headers.common['token'] = this.token;
                this.$socket = socketio(process.env.VUE_APP_SERVICE_URL);
                this.$socket.on('connect', () => {
                    this.$socket.emit('authenticate', {token: this.token});
                });
                location.href = '/';
            }
        },
        mounted() {
            this.use();
        },
    };
</script>